module.exports = __webpack_public_path__ + "static/media/degradado.5d383037.png";